import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

/**
 * SideScrollingTab - can be wrapped onto nav-tabs/react-tab, ul, ol,
 * to create a dynamic and horizontally scrollable tabs 
 * with smooth animation.
 * 
 * @param {node} children - any jsx component to apply side scroll
 * @param {bool} hideScrollButtons - hide left and right scroll caret/button
 * @param {bool} dragToScroll - drag element using mouse to scroll horizontally
 * @returns jsx component
 */

// note: feel free to add configurations if needed.

const SideScrollingTab = ({
  children, 
  hideScrollButtons,
  dragToScroll,
}) => {
  const ref = useRef(null)

  const handleScrollLeftRight = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  const handleDragToScroll = (target, isDisabled) => {

    // if dragToScroll === false, disable drag to scroll functionality
    if(!isDisabled) return false

    const slider = target
    let isDown = false;
    let startX;
    let scrollLeft;
    
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      // eslint-disable-next-line prefer-destructuring
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3.5; // scroll-fast
      slider.scrollLeft = scrollLeft - walk;
    });

    return true
  }

  useEffect(() => {
    handleDragToScroll(ref.current, dragToScroll)
  }, [])

  return (
    <div className="horizontal-scroll-tab-container" style={{ padding: !hideScrollButtons ? '0 25px' : '0'}}>
      {
        !hideScrollButtons && (
          <div className="scroll-button-container">
            <button type="button" className="btn text-dark scroll-tab-caret-left" onClick={() => handleScrollLeftRight(-100)}><i className="fa fa-caret-left fa-lg" /></button>
            <button type="button" className="btn text-dark scroll-tab-caret-right" onClick={() => handleScrollLeftRight(100)}><i className="fa fa-caret-right fa-lg" /></button>
          </div>
        )
      }
      <div className="scroll-nav-container" ref={ref}>
        {children}
      </div>
    </div>
  )
}

SideScrollingTab.defaultProps = {
  hideScrollButtons: false,
  dragToScroll: false,
};

SideScrollingTab.propTypes = {
  children: PropTypes.node.isRequired,
  hideScrollButtons: PropTypes.bool,
  dragToScroll: PropTypes.bool,
};

export default SideScrollingTab
